import { useRouter } from "next/router";
import * as React from "react";
import { track } from "../../track";
import { NavigationUserEvents } from "../../events/navigation";

// // // //

/**
 * PageTrack
 * Implements page "Page Loaded" event for an individual page
 */
export function PageTrack(props: { children: React.ReactNode }) {
    const router = useRouter();
    const { children } = props;

    React.useEffect(() => {
        track(NavigationUserEvents.pageLoaded, {
            path: router.asPath,
            pathname: router.pathname,
        });
    }, []);

    return <>{children}</>;
}
